"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUseMock = exports.setUseMock = exports.mockAdapter = exports.axios = void 0;
/**
 * Axios configuration and mock configuration
 */
const axios_1 = __importDefault(require("axios"));
const axios_mock_adapter_1 = __importDefault(require("axios-mock-adapter"));
const content_mock_1 = require("../services/mock/content-mock");
const axios = axios_1.default.create({
    timeout: 70000,
    headers: { 'Cache-Control': 'no-cache' }
});
exports.axios = axios;
let useMock = false;
const mockAdapter = new axios_mock_adapter_1.default(axios, { delayResponse: 0 });
exports.mockAdapter = mockAdapter;
const defaultMockAdapter = axios.defaults.adapter;
function isUseMock() {
    return useMock;
}
exports.isUseMock = isUseMock;
// Disable mocking
mockAdapter.restore();
function setMockAdapter() {
    if (isUseMock()) {
        const eventLogUrl = '/commservices-eventlog/api/v2/event';
        const eventLogUrlRegex = new RegExp(`${eventLogUrl}`);
        const eventLogUrlRegexInvalid = new RegExp(`${eventLogUrl}/invalid`);
        const eventLogUrlRegexError = new RegExp(`${eventLogUrl}/error`);
        const priorAuthFeatureContentRegex = new RegExp('commservices-content/api/v1/content/feature/member/sc/priorauth');
        const nonExistentFeatureContentRegex = new RegExp('commservices-content/api/v1/content/feature/member/sc/NonExistantFeature');
        const errorFeatureContentRegex = new RegExp('commservices-content/api/v1/content/feature/member/sc/Error');
        // Enable mocking
        axios.defaults.adapter = defaultMockAdapter;
        // saml assertion mock responses
        // successful response
        mockAdapter.onGet('/unit-test/member/apitoken').reply(200, {
            assertion: 'saml-assertion-token',
            environment: 'dev',
            region: 'LOEUT1'
        });
        // no token
        mockAdapter.onGet('/unit-test/member/apitoken/empty').reply(200);
        // no region to simulate QA and PROD response
        mockAdapter.onGet('/unit-test/member/apitoken/noregion').reply(200, {
            assertion: 'saml-assertion-token',
            environment: 'dev'
        });
        // token expired
        mockAdapter.onGet('/unit-test/member/apitoken/expired').reply(401);
        // member authentication mocks
        // jwt
        // success
        mockAdapter.onGet('/unit-test/auth/member/jwt').reply(200, { token: 'comm-services-jwt-initial' });
        // no token
        mockAdapter.onGet('/unit-test/auth/member/jwt/notoken').reply(200, { token: '' });
        // member context
        // success
        mockAdapter.onGet('/unit-test/member/context').reply(200, { token: 'comm-services-jwt-enhanced' });
        // no data
        mockAdapter.onGet('/unit-test/member/context/nodata').reply(200);
        // members list
        mockAdapter.onGet('/unit-test/memberinformation/memberlist/HEALTH/nophi').reply(200, [
            {
                id: 1001,
                name: 'John Doe',
                birthDate: '10/01/1970'
            },
            {
                id: 1002,
                name: 'Mary Doe',
                birthDate: '06/30/1976'
            }
        ]);
        /*-----------------*\
        | EventLog Response |
        \*-----------------*/
        mockAdapter.onPost(eventLogUrlRegexInvalid)
            .reply(200, { code: 4, text: 'invalid' });
        mockAdapter.onPost(eventLogUrlRegexError)
            .reply(500, null);
        // this should be the last one for eventlog reponses, as if none of the above are met this one is returned
        mockAdapter.onPost(eventLogUrlRegex)
            .reply(200, { code: 0, text: 'success' });
        // ------------------------------ LEDS responses ----------------------------------
        // leds authenticate responses
        mockAdapter.onPost('/unit-test/member/authenticate').reply(200, { sessionToken: 'leds-jwt-12345abcde67890' });
        mockAdapter.onPost('/unit-test/member/authenticate/nulltoken').reply(200, { sessionToken: '' });
        mockAdapter.onPost('/unit-test/member/authenticate/error500').reply(500);
        // leds prior authorizations
        mockAdapter.onGet('/unit-test/authorizations').reply(200, [
            {
                authNumber: 1001,
                status: 'In Review'
            },
            {
                authNumber: 1002,
                status: 'Received'
            }
        ]);
        // leds prior authorization detail
        mockAdapter.onGet('/unit-test/authorizations/1001').reply(200, {
            authNumber: 1001,
            status: 'In Review',
            letters: []
        });
        /*----------------------*\
        | Generic Error Response |
        \*----------------------*/
        // token expired
        mockAdapter.onGet('/unit-test/leds-token-expired').reply(419);
        // unknown error
        mockAdapter.onGet('/unit-test/error500').reply(500);
        /*----------------*\
        | Content Response |
        \*----------------*/
        mockAdapter.onGet(priorAuthFeatureContentRegex).reply(200, content_mock_1.PriorAuthContentSuccess);
        mockAdapter.onGet(nonExistentFeatureContentRegex).reply(200, { contentItems: [] });
        mockAdapter.onGet(errorFeatureContentRegex).reply(500);
    }
}
function setUseMock(vUseMock) {
    useMock = vUseMock;
    setMockAdapter();
}
exports.setUseMock = setUseMock;
//# sourceMappingURL=config.js.map